import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { DashlineSeparator, buttonStyle } from '../../../components/common/CommonStyle';
import { Description, LinkedSocialAccountItem, LinkedSocialAccounts } from './ChangeEmailStyle';
import EmailCaption from './EmailCaption';
import Button from '../../../atoms/buttons/Button';
import GoogleIcon from '../../../atoms/icons/GoogleIcon';
import { setChangeEmailVerifyData } from '../../../actions/authActions';
import AppleIcon from '../../../atoms/icons/AppleIcon';

const ChangeEmailButton = ({ email, socialAccounts }) => {
  const dispatch = useDispatch();

  const handleNextClick = () => {
    dispatch(
      setChangeEmailVerifyData({
        email,
        redirectTo: 'change_new_email',
        hasError: false,
        status: null,
        maxAttamptReached: false,
      })
    );
  };

  const renderSocialIcon = (type: string): ReactElement | null => {
    switch (type) {
      case 'google':
        return <GoogleIcon />;
      case 'apple':
        return <AppleIcon />;
      default:
        return null;
    }
  };

  return (
    <>
      <Description>
        Need to update your email address? No problem! Simply tap the &quot;Change my email&quot; button and provide
        your new email address. We&apos;ll immediately send a 6-digit passcode to your new email for verification. Enter
        the correct code, and your email address will be successfully updated.
      </Description>
      <DashlineSeparator />
      <EmailCaption label={'Current email:'} email={email} />
      {socialAccounts?.length > 0 && (
        <LinkedSocialAccounts>
          {socialAccounts.map(social => (
            <LinkedSocialAccountItem key={social.id}>
              {renderSocialIcon(social.social_site_name)} <span>account linked</span>
            </LinkedSocialAccountItem>
          ))}
        </LinkedSocialAccounts>
      )}

      <DashlineSeparator />
      <div style={{ textAlign: 'center' }}>
        <Button
          customStyle={{ ...buttonStyle, margin: '20px 0px' }}
          buttonType="primaryRed"
          type="button"
          name="next"
          onClick={handleNextClick}
        >
          Change my email
        </Button>
      </div>
    </>
  );
};

export default ChangeEmailButton;
